import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classNames from 'classnames/bind';
import { IconInformationFill } from '@saucelabs/ds-icons';
import { Tooltip } from '@saucelabs/ds-tooltip';
import { Map } from 'immutable';

import Styles from './ListViewHeader.styles';

const context = classNames.bind(Styles);

export const HEADER_TYPES = Object.freeze({
  APP_GROUP_HEADER: 'APP_GROUP_HEADER',
  APP_VERSIONS_HEADER_IOS: 'APP_VERSIONS_HEADER_IOS',
  APP_VERSIONS_HEADER_ANDROID: 'APP_VERSIONS_HEADER_ANDROID',
  REAL_DEVICE_HEADER: 'REAL_DEVICE_HEADER',
  APP_VERSIONS_HEADER_SESSION: 'APP_VERSIONS_HEADER_SESSION',
  REAL_DEVICE_UPLOAD_TO_SD_HEADER: 'REAL_DEVICE_UPLOAD_TO_SD_HEADER',
});

const HEADER_OPTIONS = Object.freeze({
  APP_GROUP_HEADER: {
    CLASS_NAME: 'app-group-header',
    NUMBER_OF_HEADLINES: 7,
  },
  APP_VERSIONS_HEADER_IOS: {
    CLASS_NAME: 'app-versions-header-ios',
    NUMBER_OF_HEADLINES: 7,
  },
  APP_VERSIONS_HEADER_ANDROID: {
    CLASS_NAME: 'app-versions-header-android',
    NUMBER_OF_HEADLINES: 6,
  },
  REAL_DEVICE_HEADER: {
    CLASS_NAME: 'real-device-header',
    NUMBER_OF_HEADLINES: 3,
  },
  APP_VERSIONS_HEADER_SESSION: {
    CLASS_NAME: 'app-versions-header-session',
    NUMBER_OF_HEADLINES: 6,
  },
  REAL_DEVICE_UPLOAD_TO_SD_HEADER: {
    CLASS_NAME: 'real-device-upload-to-sd-header',
    NUMBER_OF_HEADLINES: 3,
  },
});

const ListViewHeader = ({ headlines, infoTooltips, type }) => (
  <div className={context(Styles.container, HEADER_OPTIONS[type].CLASS_NAME)}>
    {headlines.map((headline) => {
      const infoTooltip = infoTooltips.get(headline);
      return (
        <div
          key={headline}
          className={Styles.headline}
        >
          <Tooltip
            delay={300}
            id={`list-view-header-${headline.replace(/\s/g, '')}-tooltip`}
            placement="top"
            title={headline}
          >
            <div>{headline}</div>
          </Tooltip>

          {infoTooltip && (
            <Tooltip
              id={`list-view-header-${headline.replace(/\s/g, '')}-info`}
              placement="top"
              title={infoTooltip}
            >
              <div
                className={Styles['info-icon']}
                data-qa="list-view-header-info-icon"
              >
                <IconInformationFill className="text-gray-500 fill-current" />
              </div>
            </Tooltip>
          )}
        </div>
      );
    })}
  </div>
);

ListViewHeader.propTypes = {
  /* eslint-disable react/require-default-props */
  headlines: (props, propName, componentName) => {
    const { headlines, type } = props;
    if (!headlines) {
      return new Error(`${componentName}: "${propName}" is required`);
    }
    if (
      !Array.isArray(headlines) ||
      headlines.length !== HEADER_OPTIONS[type].NUMBER_OF_HEADLINES ||
      !headlines.every((item) => typeof item === 'string')
    ) {
      return new Error(`${componentName}: "${propName}" needs to be an array of ${HEADER_OPTIONS[type].NUMBER_OF_HEADLINES} strings`);
    }
    return null;
  },
  /* eslint-enable react/require-default-props */
  infoTooltips: ImmutablePropTypes.mapOf(
    PropTypes.string,
    PropTypes.string,
  ),
  type: PropTypes.oneOf([
    HEADER_TYPES.APP_GROUP_HEADER,
    HEADER_TYPES.APP_VERSIONS_HEADER_IOS,
    HEADER_TYPES.APP_VERSIONS_HEADER_ANDROID,
    HEADER_TYPES.APP_VERSIONS_HEADER_SESSION,
    HEADER_TYPES.REAL_DEVICE_HEADER,
    HEADER_TYPES.REAL_DEVICE_UPLOAD_TO_SD_HEADER,
  ]).isRequired,
};

ListViewHeader.defaultProps = {
  infoTooltips: Map(),
};

export default ListViewHeader;
